export const getLocalFileKey = (file: File): string =>
  `${file.name}-${file.size}-${file.lastModified}`;
